<!-- Spinner -->
<div class="flex justify-center">
  <div class="flex justify-center items-center w-[60px] h-[58px] relative overflow-hidden px-1">
    <div class="w-full h-4 relative rounded-[300px] border-2 border-[#d3dae6]">
      <div
        class="w-[15.4px] h-2.5 absolute left-[0.5px] top-[1px] rounded-[300px] bg-[#0a0a0a] animate-slide-toggle"
      ></div>
    </div>
  </div>
</div>

